/** A community lives inside whichever app you are already signed in to, so the link has to carry
 *  that app's prefix — a chauffeur must never be bounced to the office door to read their chat. */
export const communityBase = (pathname = window.location.pathname) =>
  pathname.startsWith("/portal/driver") ? "/portal/driver/community"
    : pathname.startsWith("/admin") ? "/admin/community"
    : "/app/community";

export const homeFor = (pathname = window.location.pathname) =>
  pathname.startsWith("/portal/driver") ? "/portal/driver"
    : pathname.startsWith("/admin") ? "/admin"
    : "/app";

export const when = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace("T", " ");
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

export const day = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export const ago = (iso) => {
  if (!iso) return "";
  const seconds = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (Number.isNaN(seconds)) return "";
  if (seconds < 60) return "just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return day(iso);
};

export const ROLE_TONE = {
  owner: "border-gold/40 bg-gold/10 text-gold",
  leader: "border-sky-500/40 bg-sky-500/10 text-sky-300",
  treasurer: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300",
  moderator: "border-violet-500/40 bg-violet-500/10 text-violet-300",
  member: "border-ink-600 bg-ink-700 text-slate-400",
};

export const allows = (community, area, level = "view") => {
  const order = { none: 0, view: 1, limited: 2, full: 3 };
  return (order[community?.my_permissions?.[area]] || 0) >= order[level];
};

/** The websocket carries new messages and typing the instant they happen; polling is the backstop
 *  for an environment where the upgrade never completes. */
export const socketUrl = (communityId, token) =>
  `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws/community/${communityId}`
  + `?token=${encodeURIComponent(token || "")}`;
